export * from './ubiCard.component';
export * from './ubiCardBlur.directive';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiCard/index.ts